
    var riot = require('riot')
    riot.tag2('swish-modal-body', '<div class="swish-modal-body"> <div class="swish-modal-content"> <div class="icon-braintree-swish-mobile"></div> <div class="swish-modal-content-divider"></div> <ol class="formatted swish-modal-content-instructions"> <li>Öppna Swish-appen. </li> <li>Godkänn köpet med BankID.</li> <li>Betalningen är klar. </li> </ol> </div> <div class="swish-modal-logo"> <div class="icon-braintree-swish-large"></div> </div> </div>', '', '', function(opts) {
});
    
  


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/ui/checkout2/swish-modal-body.riot.html